/**
 * useCapability Hook
 * 
 * Single source of truth for customer capability decisions.
 * LAT-02: "The resolver is the only reader"
 * LAT-03: No screen contains a branch naming a customer
 * 
 * Input: current customer from Redux store
 * Returns: derived capability flags for gating UI surfaces
 */

import { useSelector } from 'react-redux';

export function useCapability() {
  const activeCustomer = useSelector((state) => state.customer.activeCustomer);

  // OD-1 defaults: no mode = beacon + both
  const trackingMode = activeCustomer?.trackingMode || 'beacon';
  const supplyMode = activeCustomer?.supplyMode || 'both';

  return {
    // Raw values
    trackingMode,
    supplyMode,

    // Tracking mode flags
    isManualOnly: trackingMode === 'manual',
    isBeaconOnly: trackingMode === 'beacon',
    isHybrid: trackingMode === 'hybrid',

    // Supply mode flags
    hasSupply: supplyMode === 'supply_only' || supplyMode === 'both',
    hasDemand: supplyMode === 'demand_only' || supplyMode === 'both',
    hasBoth: supplyMode === 'both',

    // Surface access gates
    canAccessManualSurfaces: trackingMode === 'manual' || trackingMode === 'hybrid',
    canAccessBeaconSurfaces: trackingMode === 'beacon' || trackingMode === 'hybrid',

    // Customer context (for display, not branching)
    customerId: activeCustomer?.id || null,
    customerName: activeCustomer?.name || '',
  };
}

export default useCapability;
